export const dataTestId = 'toast-clickable-part';
